// extracted by extract-css-chunks-webpack-plugin
module.exports = {"college":"college_1HqoS","title":"title_riqF1","content":"content_1PY5b"};